import { useQuery } from '@tanstack/react-query'
import { ReportController } from 'src/controllers/report.controller'
import { ReportResponseDto } from 'src/dto/report.dto'

const reportController = new ReportController()

export function useGetReport(username: string, idRelatorio: string) {
  return useQuery<ReportResponseDto, Error>({
    queryKey: ['getReport', username, idRelatorio],
    queryFn: () => reportController.getReport(username, idRelatorio),
    enabled: !!username && !!idRelatorio
  })
}
